import React, { forwardRef, useImperativeHandle } from "react";
import { Form, Row, Col } from "react-bootstrap";

const FormatIIForm = forwardRef(({ formData, setFormData }, ref) => {
  useImperativeHandle(ref, () => ({
    validate: () => {
      const {
        year,
        physicalTarget,
        achievement,
        financialTarget,
        financialAchievement,
      } = formData.formatII || {};
      return !!(
        year &&
        physicalTarget &&
        achievement &&
        financialTarget &&
        financialAchievement
      );
    },
  }));
  const handleChange = (field, value) => {
    setFormData({
      ...formData,
      formatII: { ...formData.formatII, [field]: value },
    });
  };
  const generateYearRanges = (startYear, endYear) => {
    const ranges = [];
    for (let year = startYear; year < endYear; year++) {
      ranges.push(`${year}-${year + 1}`);
    }
    return ranges;
  };

  const yearRanges = generateYearRanges(1999, new Date().getFullYear());
  return (
    <div>
      <Form>
        <Row className="mb-3">
          <Col>
            <Form.Group className="mb-3">
              <Form.Label>Year</Form.Label>
              <Form.Control
                as="select"
                placeholder="Year"
                onChange={(e) => handleChange("year", e.target.value)}
              >
                <option value="">Select Year</option>
                {yearRanges.map((yr) => (
                  <option key={yr} value={yr}>
                    {yr}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>

          <Col>
            <Form.Group controlId="physicalTarget">
              <Form.Label>Physical Target</Form.Label>
              <Form.Control
                type="text"
                placeholder="Physical Target (in Ha./Km)"
                value={formData.formatII?.physicalTarget || ""}
                onChange={(e) => handleChange("physicalTarget", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="achievement">
              <Form.Label>Achievement</Form.Label>
              <Form.Control
                type="text"
                placeholder="Achievement (in Ha./Km)"
                value={formData.formatII?.achievement || ""}
                onChange={(e) => handleChange("achievement", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="financialTarget">
              <Form.Label>Financial Target (Lakhs)</Form.Label>
              <Form.Control
                type="number"
                placeholder="Financial Target (Lakhs)"
                min={0}
                value={formData.formatII?.financialTarget || ""}
                onChange={(e) =>
                  handleChange("financialTarget", e.target.value)
                }
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="financialAchievement">
              <Form.Label>Financial Achievement</Form.Label>
              <Form.Control
                type="number"
                min={0}
                placeholder="Financial Achievement (in Ha./Km)"
                value={formData.formatII?.financialAchievement || ""}
                onChange={(e) =>
                  handleChange("financialAchievement", e.target.value)
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Group controlId="meetingDates">
              <Form.Label>Meeting Dates</Form.Label>
              <Form.Control
                type="text"
                placeholder="Meeting Dates"
                value={formData.formatII?.meetingDates || ""}
                onChange={(e) => handleChange("meetingDates", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
});

export default FormatIIForm;
